define.alias("ember-basic-dropdown/components/basic-dropdown-wormhole", "calendar/components/basic-dropdown-wormhole");